import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FluencyAudioService {

  constructor(
    private appConfig: AppConfigService,
    private http: HttpClient
  ) {
  }

  getFluencyAudioFile(attemptLink: string): Observable<string> {
    const url = `${this.appConfig.apiUrl}${attemptLink}`;
    return this.http.get(url, { responseType: 'blob' })
      .pipe(map(blob => URL.createObjectURL(blob)));
  }
}
